import { Component } from '@angular/core';

@Component({
    selector: 'ecom',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class EcomComponent {}
